import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../i18n';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // Preserve the error in the console for debugging while avoiding a blank app.
    // eslint-disable-next-line no-console
    console.error(error);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <div className="min-h-screen bg-background flex items-center justify-center px-6">
          <div className="max-w-md text-center">
            <h1 className="text-on-background text-2xl font-bold mb-3">
              {i18n.t('errorBoundary.title')}
            </h1>
            <p className="text-on-surface mb-4">
              {i18n.t('errorBoundary.description')}
            </p>
            <button
              type="button"
              className="bg-primary text-on-primary px-4 py-2 rounded-full font-semibold"
              onClick={() => window.location.reload()}
            >
              {i18n.t('errorBoundary.reload')}
            </button>
          </div>
        </div>
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
